import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import CreatorGridService from "../service/CreatorGridService";
import Logger from "../../services/Logger";
import { trackEvent } from "../../services/GoogleAnalytics";

export default function CreatorGridEdit() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const type = searchParams.get('type') || null;
    const language = searchParams.get('language') || null;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        trackEvent("entered", { name: "CreatorGridEdit" });
    }, []);

    useEffect(() => {
        const loadPuzzle = async () => {
            try {
                setLoading(true);
                setError(null);
                const puzzleData = await CreatorGridService.getDraftGridPuzzle(language, type);
                
                if (puzzleData && puzzleData.code === "NO_DATA") {
                    setError("No draft grid puzzle found. Please create a new puzzle.");
                } else if (puzzleData && puzzleData.id) {
                    // Navigate to the creator-specific edit page with the puzzle ID
                    // This route will render the edit component without requiring admin auth
                    navigate(`/creator/grid/edit/${puzzleData.id}`, { replace: true });
                } else {
                    setError("No draft grid puzzle found.");
                }
            } catch (err) {
                Logger.error("Error loading draft grid puzzle:", err);
                setError("Failed to load puzzle. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        loadPuzzle();
    }, [navigate, type, language]);

    if (loading) {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
                <CircularProgress />
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Loading puzzle...
                </Typography>
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ p: 4 }}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate("/creator")}
                    sx={{ mb: 2 }}
                >
                    Back to Creator
                </Button>
                <Alert severity="error">{error}</Alert>
            </Box>
        );
    }

    // This should not be reached if navigation works, but just in case
    return (
        <Box sx={{ p: 4 }}>
            <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate("/creator")}
                sx={{ mb: 2 }}
            >
                Back to Creator
            </Button>
            <Typography variant="h6">Redirecting to edit page...</Typography>
        </Box>
    );
}

